import { SERVICE_ID_PREFIX } from './constants'

export function getServiceId(merchantId: string): string {
	return `${merchantId}-${SERVICE_ID_PREFIX}`
}
